import enumeration from "./enumeration";

const TransactionStatus = {
  SUCCESS: "SUCCESS",
  VOID: "VOID",
};

export default enumeration(TransactionStatus);
